
<template>
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-8">
          <strong class="card-title mb-3">Insider Transaction</strong>
        </div>
        <div class="col-md-3"></div>
        <div class="col-md-1">
          <goback></goback>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="row mb5">
        <div class="col-md-6">
          <div class="form-group">
            <v-select
              :options="companyList"
              :placeholder="'Select Company'"
              :label="'companyname'"
              v-model="selComp"
              @input="getCompData"
            >
              <!-- <div class="spinner" v-show="spinner">Loading...</div> -->
            </v-select>
          </div>
        </div>
        <div class="col-md-3"></div>
        <div class="col-md-3">
        </div>
      </div>
      <div class="table-responsive app" v-dragscroll="true"  v-if="rawData.co_code">
        <table class="table table-bordered app-inner" v-if="rawData.co_code">
          <thead>
            <tr>
              <th
                v-for="field in tableFields"
                v-bind:key="'field'+field.title"
                style="font-size:.92em"
                class="data-cell"
              >{{field.name}}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td v-for="field in tableFields" v-bind:key="field.name">{{rawData[field.title]}}</td>
            </tr>
          </tbody>
          <br/><br/>
        <!-- </table> -->
      <!-- </div>
      <div class="table-responsive app"> -->
        <!-- <table class="table table-bordered app-inner"> -->
          <thead v-if="rawData.final_data">
            <tr>
              <th
                v-for="field in tableColumns"
                v-bind:key="'field'+field.title"
                style="font-size:.92em"
                class="data-cell column-sort"
              >{{field.name}}</th>
            </tr>
          </thead>
          <tbody v-if="rawData.final_data">
            <tr v-for="(row,index) in rawData.final_data" v-bind:key="'row'+index">
              <td v-for="field in tableColumns" v-bind:key="field.name+index">
                <span v-if="field.type==='date'">{{getDate(row[field.title])}}</span>
                <span v-else>{{row[field.title]}}</span>

                </td>
            </tr>
          </tbody>
          <tfoot v-if="rawData.final_data && rawData.final_data.length==0">
            <tr>
              <td :colspan="(tableColumns.length)">
                <i class="fa fa-info cwhite"></i> No data found.
              </td>
            </tr>
          </tfoot>
        </table>        
      </div>
      <div class="row" v-else>
        <div class="col-md-12">
          <div class="alert alert-danger"> No data found.</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import http from "@/lib/http";
import { commonMixins } from "../../assets/mixins/common.js";

export default {
  mixins: [commonMixins],
  created() {
    this.url = this.rawDataApi;
    this.getCompaniesList();
    // this.getRawData();
  },
  data() {
    return {
      rawDataType: 0,
      tableFields: [
        {
          title: "co_code",
          name: "Company Code",
          isNumeric: false,
          sort_order: 0
        },
        {
          title: "co_name",
          name: "Company",
          isNumeric: false,
          sort_order: 0
        },
        {
          title: "acquisition",
          name: "Acquisition",
          isNumeric: true,
          sort_order: 0
        },
        {
          title: "disposal",
          name: "Disposal",
          isNumeric: true,
          sort_order: 0
        },
        {
          title: "pledge",
          name: "Pledge",
          isNumeric: true,
          sort_order: 0
        },
        {
          title: "revoke",
          name: "Revoke",
          isNumeric: true,
          sort_order: 0
        }
      ],
      rawDataList: [],
      rawDataApi: "insiderTransactions",
      rawData: {},
      url: "",
      actions: [],
      selComp: '',
      companyList: [],
      tableColumns: []
      // company: {co_code: '', companyname: ''},
    };
  },
  methods: {
    getRawData() {
      this.rawData = {};
      let myself = this;
      let data = {co_code: this.selComp.co_code};
      http.post(this.url, data, (error, response) => {
        if(response.length>0)
        myself.rawData = response[0];
        myself.getTableColumns();
      });
    },
    getCompaniesList() {
      let _this = this;
      http.get("getCompanyMaster", {}, function(error, response) {
        var companyList = response;
        if (companyList.length > 0) {
          _this.companyList = _this.sorted_fields_asc(
            companyList,
            "companyname"
          );
          if (!localStorage.getItem("selcomp")) {
            _this.selComp = _this.companyList[0];
            localStorage.setItem("selcomp", JSON.stringify(_this.selComp));
          } else {
            _this.selComp = JSON.parse(localStorage.getItem("selcomp"));
          }
          // _this.company.companyname = _this.selComp.companyname;
          // _this.company.co_code = _this.selComp.co_code;
        }
      });
    },
    getCompData() {
      if (this.selComp !== "") {
        localStorage.setItem("selcomp", JSON.stringify(this.selComp));
        // this.company.companyname = this.selComp.companyname;
        // this.company.co_code = this.selComp.co_code;
        console.log(
          "Company",
          this.selComp.co_code,
          "=>",
          this.selComp.companyname
        );
        this.getRawData();
      }
    },
    getTableColumns(){
      this.tableColumns = [];
        if (this.rawData.co_code && this.rawData.final_data && this.rawData.final_data.length > 0) {
          var rowKeys = Object.keys(this.rawData.final_data[0]);
          console.log("rowKeys", rowKeys);
          rowKeys.forEach((val, key) => {
            console.log("Rows", key, val);
            if (val !== "CO_CODE" && val !== "BSECODE" && val !== "CO_NAME" && val !== "_id") {
              this.tableColumns.push({
                title: val,
                name: this.getCustomLabel(val)
                  ? this.getCustomLabel(val)
                  : this.getLabel(val),
                type: (val==='FROMDTACQ' || val==='INTDATE' || val==='REPEXCH' || val==='TODTACQ')? 'date':'',
                sort_order:
                val === "PERSONNAME"
                ? 0
                : val === "CATEGORYear"
                ? 1
                : val === "SECTYearPEPR"
                    ? 2
                    : val === "SECNOPR"
                    ? 3
                    : val === "SECPERCPR"
                    ? 4
                    : val === "SECTYearPE"
                    ? 5
                    : val === "SECNO"
                    ? 7
                    : val === "SECVALUE"
                    ? 8
                    : val === "TRANSTYearPE"
                    ? 9
                    : val === "SECTYearPEPO"
                    ? 10
                    : val === "SECNOPO"
                    ? 11
                    : val === "SECPERCPO"
                    ? 12
                    : val === "FROMDTACQ"
                    ? 13
                    : val === "TODTACQ"
                    ? 14
                    : val === "INTDATE"
                    ? 15
                    : val === "ACQMODE"
                    ? 16
                    : val === "EXCH"
                    ? 17
                    : val === "REPEXCH"
                    ? 18
                    :99
              });
            }
          });
          this.tableColumns = this.sorted_fields_asc(
            this.tableColumns,
            "sort_order"
          );
        }
        console.log(this.tableRows, this.tableColumns);
    }
  }
};
</script>
<style>
form .col-md-3 {
  width: 40%;
}
.table th.column-sort {
  cursor: pointer;
}

.table td {
  padding: 5px 10px 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/market-data/insiderTransaction.vue